/* M1o2 PDP - per-variant gallery images.
 *
 * A variant's m1o2.images metafield (list of image files) replaces the gallery while that
 * variant is selected; other variants show the product media. sections/m1o2-pdp-main.liquid
 * renders every set as thumbs tagged data-thumb-set ("product" or a variant id) and only
 * loads this file when at least one variant has images. Listens for the m1o2:variant-change
 * event that assets/m1o2-pdp-main.js fires after a Size-pill change; selecting a thumb is
 * done by clicking it, so the hero swap stays in m1o2-pdp-main.js.
 */
(function () {
	'use strict';

	function initSection(section) {
		var strip = section.querySelector('.m1o2-pdp-main__thumbs');
		if (!strip) return;
		var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.m1o2-pdp-main__thumb[data-thumb-set]'));

		function hasSet(id) {
			return thumbs.some(function (t) { return t.getAttribute('data-thumb-set') === id; });
		}

		section.addEventListener('m1o2:variant-change', function (e) {
			var v = e.detail && e.detail.variant;
			if (!v) return;
			var set = hasSet(String(v.id)) ? String(v.id) : 'product';

			var visible = [];
			thumbs.forEach(function (t) {
				var show = t.getAttribute('data-thumb-set') === set;
				t.hidden = !show;
				if (show) {
					visible.push(t);
				} else {
					t.classList.remove('is-active');
					t.setAttribute('aria-selected', 'false');
				}
			});
			strip.hidden = visible.length < 2;
			if (!visible.length) return;

			/* Product set: keep the variant's own image when it is one of the thumbs. A variant
			   whose image is not in the strip was already shown by m1o2-pdp-main.js - leave it. */
			if (set === 'product') {
				var match = visible.filter(function (t) { return String(t.getAttribute('data-media-id')) === String(v.media_id); })[0];
				if (match) { match.click(); return; }
				if (v.img) return;
			}
			visible[0].click();
		});
	}

	document.querySelectorAll('.m1o2-pdp-main[data-section-id]').forEach(initSection);
})();
